import { session as _session } from "@descope/nextjs-sdk/server";

import { descopeConfig } from "@/config/descope";

// SDK 0.15 verifies the cookie JWT here (not via a middleware-set header),
// so the callsite must supply the same projectId the middleware used;
// otherwise it falls back to DESCOPE_PROJECT_ID env and drifts per environment.
export function session() {
  return _session({ projectId: descopeConfig.projectId });
}
